import { RefObject, useState } from 'react';

export const useKeyboardInputToggle = (inputRef: RefObject<HTMLInputElement>) => {
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  const toggleKeyboardInput = () => {
    setKeyboardVisible((prev) => {
      const next = !prev;

      if (next) {
        if (typeof window !== 'undefined') {
          window.requestAnimationFrame(() => inputRef.current?.focus());
        } else {
          inputRef.current?.focus();
        }
      } else {
        inputRef.current?.blur();
      }

      return next;
    });
  };

  return { keyboardVisible, toggleKeyboardInput };
};
